import { getShortlistedSupplierDetails } from '@bridebook/web/lib/shortlist/selectors';
import {
  getIsShowroundPromoModalVisible,
  getShowroundPromoModalSupplierId,
} from '@bridebook/web/lib/ui/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';

const ShowroundPromoModal = lazyComponent(() => import('./showround-promo-modal'));

export const ShowroundPromoModalLazy = () => {
  const isVisible = useSelector(getIsShowroundPromoModalVisible);
  const supplierId = useSelector(getShowroundPromoModalSupplierId);
  const supplier = useSelector((state) =>
    supplierId ? getShortlistedSupplierDetails(state, supplierId) : null,
  );

  if (!isVisible || !supplier) {
    return null;
  }

  return <ShowroundPromoModal supplier={supplier} />;
};
